export const birdSpecies = [
  "American Robin",
  "Bald Eagle",
  "Blue Jay",
  "Cardinal",
  "Chickadee",
  "Common Loon",
  "Crow",
  "Dove",
  "Duck",
  "Falcon",
  "Goldfinch",
  "Hawk",
  "Heron",
  "Hummingbird",
  "Kingfisher",
  "Magpie",
  "Mockingbird",
  "Owl",
  "Parrot",
  "Peacock",
  "Pelican",
  "Penguin",
  "Pigeon",
  "Raven",
  "Sparrow",
  "Swallow",
  "Swan",
  "Turkey",
  "Vulture",
  "Woodpecker",
  "Wren"
];
